import BaseComponent from "../../base/base_component";
import Device from '../../utils/device/device';
import DOM from "../../utils/dom";
import {namedSetInterval} from "../../../../common/utils/time-functions";

const gameSessionTimerView = require('./view/game_session_timer.html');

export default class GameSessionTimerController extends BaseComponent {

    _tickingInterval;
    _initUnixTime: number;
    _currentHMS: string;
    _valueDOM;
    /**
     *
     * @type {string}
     */
    static CLASS = 'GameSessionTimerController';

    /**
     *
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-game-session-timer';

    /**
     *
     * @type {string}
     * @private
     */
    protected _selector = 'cgp-game-session-timer-component';

    start() {
        this._bakeHTML();

        this._initUnixTime = new Date().getTime();
        this._tickClock();
        this._subscribe();

        return this;
    }

    _bakeHTML(){
        this.setHTML(this.bake(gameSessionTimerView));

        this._valueDOM = this.querySelector(`.${this._selector}-value`);

        if (Device.isMobile()) {
            this.addClass('cgp-themes-small-secondary-grayed-out-text');
        } else {
            this.addClass('cgp-themes-grayed-out-text');
        }
    }

    _subscribe() {
       this._tickingInterval = namedSetInterval('GAME_SESSION_TIMER', this._tickClock.bind(this), 200);
    }

    _tickClock(){
        const currentHMS = this._secondsToHMS((new Date().getTime()) - this._initUnixTime);

        if(currentHMS !== this._currentHMS) {
            this._valueDOM.innerHTML = currentHMS;
        }

        this._currentHMS = currentHMS;
    }

    _secondsToHMS(secs) {
        function z(n){return (n<10?'0':'') + Math.floor(n);}
        secs = Math.abs(secs / 1000);
        return z(secs/3600 |0) + ':' + z((secs%3600) / 60 |0) + ':' + z(secs%60);
    }

    shutDown() {
        super.shutDown();
        this._tickingInterval && DOM.clearInterval(this._tickingInterval);
    }

}